import logo from "@/assets/brand/logo.webp";
import brandBanner from "@/assets/brand/brand-banner.jpg";
import yohalyPhoto from "@/assets/brand/yohaly-photo.png";
import yohalyHeroPhoto from "@/assets/brand/yohaly-hero.png";

export const LOGO_URL = logo;

export const BRAND_BANNER = brandBanner;

export const YOHALY_PHOTO = yohalyPhoto;
export const YOHALY_HERO_PHOTO = yohalyHeroPhoto;

export const SLOGAN = "Tu aliado para crecer en Estados Unidos";

export const CONTACT = {
  email: "info@greatsolutionsus.com",
  phone1: "786-704-1823",
  phone2: "786-227-8460",
  phone1Tel: "+17867041823",
  phone2Tel: "+17862278460",
  whatsapp: "17867041823",
  address: "12555 Orange Dr., Suite 4283",
  addressExtra: "Davie, FL 33330 · USA",
  addressFull: "12555 Orange Dr, Suite 4283, Davie, FL 33330",
  instagram: "greatsolutionsus",
  instagramUrl: "https://instagram.com/greatsolutionsus",
  location: "Florida, Estados Unidos",
  hours: [
    { day: "Lunes - Viernes", time: "9:00 AM - 6:00 PM" },
    { day: "Sábado", time: "10:00 AM - 2:00 PM" },
    { day: "Domingo", time: "Cerrado" },
  ],
};

export const NAV_LINKS = [
  { label: "Servicios", href: "#servicios" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Proceso", href: "#proceso" },
  { label: "Blog", href: "/blog", external: true },
  { label: "FAQ", href: "#faq" },
  { label: "Contacto", href: "#contacto" },
];

export const SEO = {
  title: "Great Solutions US · Impuestos, ITIN, LLC, Notaría y Seguros en Florida",
  description:
    "Great Solutions US, liderada por Yohaly Acevedo (Notary Public FL, IRS Certified, CAA), ofrece preparación de impuestos, ITIN, formación de LLC, contabilidad, notarizaciones, formularios migratorios y seguros en Florida.",
  keywords:
    "Tax Preparation Florida, IRS Certified Tax Preparer, ITIN Acceptance Agent, CAA, Bookkeeping Florida, Payroll Services, LLC Formation Florida, Business Consulting, Notary Public Florida, Remote Online Notary, Apostille Services, Immigration Forms Preparation, Health Insurance, Life Insurance, Yohaly Acevedo",
  url: "https://greatsolutionsus.com",
};
